import { render } from "./giftUser.vue?vue&type=template&id=9e35e81c&scoped=true"
import script from "./giftUser.vue?vue&type=script&lang=js"
export * from "./giftUser.vue?vue&type=script&lang=js"

import "./giftUser.vue?vue&type=style&index=0&id=9e35e81c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e35e81c"]])

export default __exports__